import React, { Component } from "react";
import { connect } from "react-redux";
import { Strings } from "../../../Resources/Strings/i18n";
import Button from "@material-ui/core/Button";
import InstallAppModal from "../../InstallAppModal/InstallAppModal";
import SuccessModal from "../../SuccessModal/SuccessModal";
import { APIResponse, OperationStatus } from "../../../Communication/Constants";
import ic_no_reports from "../../../Resources/Images/ic_no_scheduled_reports.png";
import ReportScheduleCard from './ReportScheduleCard';
import Popup from '../../Popup/Popup';

class ManageReports extends Component {
    constructor(props) {
        super(props)
        this.state={
            showDeletePopUp: false,
            showSuccessModal: false,
            deleteId: null,
            userData: JSON.parse(localStorage.getItem("myState"))
        }
    }
    componentDidMount () {
        this.getReports()
    }
    
    getReports = () => {
        this.props.setcustSpinner(true)
        if(this.state.userData) {
            let requestData = {id: this.state.userData.id}
            this.props.dashBordAction.getReports(requestData, (actionCallback) => {
                if (actionCallback.status === OperationStatus.SUCCESS) {
                    this.props.setErrorMessage("")
                    this.setState({
                        recipientCard: this.props.reportRecipients
                    }, ()=> {
                        this.props.setcustSpinner(false)
                    })
                } 
                else if (actionCallback.status === APIResponse.INVALID_USER_PROFILE) {
                    this.props.setErrorMessage("ERROR_INVALID_USER_PROFILE")
                    this.props.setcustSpinner(false)
                }
                else {
                    this.props.setErrorMessage(actionCallback.error.errorMessage)
                    this.props.setcustSpinner(false)
                }
            })
        }
    }

    deleteReport = () => {
        this.props.setcustSpinner(true)
        console.log("Deleting report")
        let requestData = { report_recipient_id: this.state.deleteId }
        this.props.dashBordAction.deleteReport(requestData, (actionCallback) => {
            if (actionCallback.status === OperationStatus.SUCCESS) {
                this.props.setErrorMessage("")
                this.getReports()
                this.setState({
                    showSuccessModal: true
                }, ()=> this.props.setcustSpinner(false))
              } else {
                //error handling
                this.props.setErrorMessage(actionCallback.error.errorMessage)
                this.props.setcustSpinner(false)
                console.log("Error while deleting")
                
              }
        })
    }
    
    handleDelete = (id) => {
        this.setState({
            showDeletePopup: true,
            deleteId: id
        })
    }

    handleResend = (recipient) => {
        let recipientData = [{
            recipient_name: recipient.recipient_name,
            recipient_email: recipient.recipient_email,
            reports: [{
                id: recipient.id,
                frequency: recipient.schedule.frequency, 
                isResend: true
            }]
        }]
        this.props.sendReportHandler(recipientData)
    }

    handleUpgradeClick = () => {
        this.props.setShowErrorModal(true)
        this.props.setErrorMessage('Please upgrade to paid plans to use this feature.')
    }

    render () {
        if (this.state.userData && (this.state.userData.plan === "PREMIUM") || (this.state.userData.plan === "PRO-PREMIUM") ||
        (this.state.userData.plan === "BASIC") || (this.state.userData.plan === "STANDARD") ||
        (this.state.userData.plan === "ADVANCED") || (this.state.userData.plan === "FREE")
        ) {
            if (this.state.recipientCard && this.state.recipientCard.length > 0) {
                return (
                    <div className="manageReportContainer flexContainer">
                        {this.state.recipientCard.map((recipient, index) => {
                            return(
                                <ReportScheduleCard 
                                    key={index}
                                    index={index}
                                    rName={recipient.recipient_name}
                                    recipientId={recipient.id}
                                    rEmail={recipient.recipient_email}
                                    rSchedule={recipient.schedule}
                                    resendReport={()=>this.handleResend(recipient)}
                                    deleteReport={()=>this.handleDelete(recipient.id)}
                                />
                            )
                        })}
                        <Popup
                            heading={Strings("DeleteRecipientPopupHeader")}
                            content={Strings("DeleteRecipentReportMessage")}
                            showCustomModal={this.state.showDeletePopup}
                            setShowCustomModal={(show) => this.setState({showDeletePopup: show})}
                            funOnSuccess={this.deleteReport}
                            leftbtn={Strings("cancel")}
                            rightbtn={Strings("YES")}
                        />
                        <SuccessModal
                            showSuccessModal={false || this.state.showSuccessModal}
                            SuccessMessage={Strings("DeleteSuccess")}
                            closeSuccessModal={()=>this.setState({showSuccessModal: false})}
                        />
                        <InstallAppModal
                            openInstallApp={this.props.openInstallApp}
                            hideModal={()=>{this.props.setOpenInstallApp(false)}}
                        />
                    </div>
                )
            }
            else {
                return(
                    <div className="manageReportContainer emptyManageReportContainer">
                        <div className="emptyImage">
                            <img src={ic_no_reports} alt={ic_no_reports} />
                        </div>
                        <div className="noReportsText1">{Strings("ScheduleReports")}</div>
                        <div className="noReportsText2">
                            {Strings("NoReports")}
                        </div>
                    </div>
                )
            }
        }
        else {
            return(
                <div className="manageReportContainer emptyManageReportContainer">
                    <div className="emptyImage">
                        <img src={ic_no_reports} alt={ic_no_reports} />
                    </div>
                    <div className="noReportsText1">{Strings("ScheduleReports")}</div>
                    <div className="noReportsText2">
                        {Strings("UpgradeToSchedule")}
                    </div>
                    <div className="manageButton">
                        <Button
                            className="blueButton"
                            variant="contained"
                            color="primary"
                            onClick={this.handleUpgradeClick}
                        >
                            {Strings("UpgradeNow")}
                        </Button>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return{
        reportRecipients: state.Dashboard.reportRecipients
    }
}
export default connect(mapStateToProps, null)(ManageReports);